var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "../Icon";
import React from 'react';
import { css, mq, styled } from "../../utils";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";
var TopBorder = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 0.25rem;\n    background-color: ", ";\n    z-index: 1100;\n  "], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 0.25rem;\n    background-color: ", ";\n    z-index: 1100;\n  "])), colors.primary);
});
var StyledHeader = styled.header(function (_a) {
    var withContact = _a.withContact;
    return "\n  width: 100%;\n  z-index: 1000;\n  position: absolute;\n  \n  " + mq({
        paddingTop: [withContact ? 0 : '0.25rem', withContact ? 0 : '0.25rem', '0.25rem'],
    }) + "\n  \n";
});
var Header = function (_a) {
    var _b = _a.logo, logo = _b === void 0 ? React.createElement(Icon.MymoriaLogo, null) : _b, transparent = _a.transparent, className = _a.className, props = __rest(_a, ["logo", "transparent", "className"]);
    return (React.createElement(StyledHeader, { withContact: !!(props.contactLabel && props.contactPhone), className: className },
        !transparent && React.createElement(TopBorder, null),
        React.createElement(HeaderMobile, __assign({ logo: logo, transparent: transparent }, props)),
        React.createElement(HeaderDesktop, __assign({ logo: logo, transparent: transparent }, props))));
};
export default Header;
var templateObject_1;
//# sourceMappingURL=Header.js.map